import { useSearchParams } from "react-router-dom";

export function useEventIdQueryParams() {
  const [searchParams] = useSearchParams();

  return {
    eventId: searchParams.get("eid"),
  };
}
